// extracted by mini-css-extract-plugin
export default {"title":"Components_title__Yi-ks"};